// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"Popover__srOnly--1vETm","hiddenInput":"Popover__hiddenInput--BswMo","root":"Popover__root--1ff8P"};